import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Add from "./Add";
import Edit from "./Edit";
import StoreDirectorProfile from "./StoreDirectorProfile";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import ResetPassword from "./ResetPassword";
import Report from "./Report";

export default function Directors() {
  const path = {
    baseRoute: "/directors",
    aliasName: "کارگردان",
    type: "Director",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    create,
    update,
    quickUpdate,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();
  const {
    getRoles,
    getCountries,
    getProductCategories,
    storeDirectorProfile,
  } = useCore();
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [showDirectorProfile, setShowDirectorProfile] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [item, setItem] = useState(false);

  useEffect(() => {
    dispatch(getList(path));
    dispatch(getRoles());
    dispatch(getProductCategories());
    dispatch(getCountries());
    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <Add
        title="افزودن کارگردان"
        show={showAdd}
        close={() => {
          setShowAdd(false);
        }}
        submit={(values) => {
          dispatch(
            create(path, values, () => {
              handleSuccessMessages("کارگردان مورد نظر با موفقیت اضافه شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Edit
        item={item}
        title="ویرایش کارگردان"
        show={showEdit}
        close={() => {
          setShowEdit(false);
        }}
        submit={(values, id) => {
          dispatch(
            update(path, id, values, () => {
              handleSuccessMessages("کارگردان مورد نظر با موفقیت ویرایش شد");
              dispatch(getList(path));
            })
          );
        }}
      />

      <StoreDirectorProfile
        item={item}
        title="ویرایش پروفایل کارگردان"
        show={showDirectorProfile}
        close={() => {
          setShowDirectorProfile(false);
        }}
        submit={(values, id) => {
          dispatch(
            storeDirectorProfile(id, values, () => {
              handleSuccessMessages("پروفایل مورد نظر با موفقیت ویرایش شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Delete
        title="حذف کارگردان"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item.id, () => {
              handleSuccessMessages("کارگردان مورد نظر با موفقیت حذف شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />
      <ResetPassword
        item={item}
        title="تغییر گذرواژه"
        show={showResetPassword}
        close={() => {
          setShowResetPassword(false);
        }}
        submite={(values, id) => {
          dispatch(
            quickUpdate(path, id, values, () => {
              handleSuccessMessages("گذرواژه تغییر یافت!");
              dispatch(getList(path));
            })
          );
        }}
      />

      <Report
        item={item}
        title="دریافت گزارش سالانه"
        show={showReport}
        close={() => {
          setShowReport(false);
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">کارگردان ها</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            <button
              onClick={() => {
                setShowAdd(true);
              }}
              className="btn btn-primary shadow-md mr-2"
            >
              افزودن کارگردان
            </button>
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">شناسه</th>
                  <th className="whitespace-nowrap text-center">تصویر</th>
                  <th className="whitespace-nowrap text-center">نام کاربری</th>
                  <th className="whitespace-nowrap text-center">
                    نام و نام خانوادگی
                  </th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item, index) => (
                    <tr key={`item_${index}`} className="intro-x">
                      <td className="w-16 text-center">{item.id}</td>
                      <td className="w-36">
                        <div className="flex justify-center">
                          <div className="w-10 h-10 image-fit zoom-in">
                            <img
                              alt=""
                              className="tooltip rounded-full"
                              src={item.avatar && item.avatar.url}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.user_name}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.first_name + " " + item.last_name}
                        </p>
                      </td>
                      <td className="table-report__action">
                        <div className="flex justify-center items-center">
                          <a
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowResetPassword(true);
                            }}
                          >
                            {" "}
                            <Icons.Key className="w-4 h-4 ml-1" />
                            تغییر پسورد
                          </a>

                          <a
                            className={`flex items-center ml-3 cursor-pointer text-theme-4`}
                            onClick={() => {
                              setItem(item);
                              setShowReport(true);
                            }}
                          >
                            {" "}
                            <Icons.CheckSquare className="w-4 h-4 ml-1" /> گزارش
                            سالانه{" "}
                          </a>

                          <a
                            className={`flex items-center ml-3 cursor-pointer ${
                              item.director_profile
                                ? "text-theme-4"
                                : "text-theme-6"
                            }`}
                            onClick={() => {
                              setItem(item);
                              setShowDirectorProfile(true);
                            }}
                          >
                            {" "}
                            <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                            پروفایل کارگردان{" "}
                          </a>
                          <a
                            className={`flex items-center ml-3 cursor-pointer`}
                            onClick={() => {
                              setItem(item);
                              setShowEdit(true);
                            }}
                          >
                            {" "}
                            <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                            ویرایش{" "}
                          </a>
                          <a
                            className="flex items-center text-theme-6 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowDelete(true);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1" />
                            حذف{" "}
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
